import { render, staticRenderFns } from "./search.vue?vue&type=template&id=b489c5a4&scoped=true"
import script from "./search.vue?vue&type=script&lang=ts"
export * from "./search.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./search.vue?vue&type=style&index=0&id=b489c5a4&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "b489c5a4",
  "b2d3b3a2"
  
)

export default component.exports